import { GET_MODULE_LIST, GET_MODULE_LIST_FAILURE, GET_MODULE_LIST_SUCCESS } from "../../Actions/types"

const initialState = {
  loading: false,
  error: "",
  data: []
}
function ModuleListReducer(state = initialState, action) {
  switch (action.type) {

    case GET_MODULE_LIST:
      return { ...state, loading: true }

    case GET_MODULE_LIST_FAILURE:
      return { ...state, data: action.payload?.data, loading: false }

    case GET_MODULE_LIST_SUCCESS:
      return { ...state, data: action.payload, loading: false }

    default:
      return state
  }
}

export default ModuleListReducer;